import { Component } from 'js-component-framework';
import Throttle from '../../utilities/Throttle';
import SmoothScroll from '../../utilities/SmoothScroll';

/**
 * Component for instantiating Button Dropdown Menu.
 */
export default class ButtonDropdownMenu extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Initalizations
    this.triggerToggleDropdown();

    // Throttle scroll event for ButtonDropdownMenu
    // Hide the dropdown on scroll
    this.buttonDropDownThrottle = new Throttle(
      this.setDropdownClosed.bind(this),
      'scroll',
      document,
      50
    );

    // Link smoothly scrolls user to respective section
    this.setSmoothScrollLink
      = new SmoothScroll('.button-dropdown-menu__list-item a');
    this.setSmoothScrollLink.init();
  }

  /**
   * Set dropdown to closed state
   */
  setDropdownClosed() {
    if (this.element.classList.contains(this.options.dropdownActiveClass)) {
      this.element.classList.remove(this.options.dropdownActiveClass);
      this.children.button.setAttribute('aria-expanded', 'false');
    }
  }

  /**
   * Trigger to show/hide dropdown
   */
  triggerToggleDropdown() {
    this.children.button.addEventListener('click', () => {
      this.element.classList.toggle(this.options.dropdownActiveClass);
      this.children.button.setAttribute('aria-expanded', this.isExpanded());
    });
  }

  /**
   * Return aria-expanded state
   * @return {String} 'true' if expanded, 'false' if not
   */
  isExpanded() {
    return ('false' === this.children.button.getAttribute('aria-expanded')) ?
      'true' : 'false';
  }
}



// WEBPACK FOOTER //
// ./client/js/components/ButtonDropdownMenu/ButtonDropdownMenu.js